import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/manager/bookings')({
  component: () => <Navigate to="/manager/orders" />,
});
